module.exports = __webpack_public_path__ + "img/KP.eb7337fb.svg";